module.exports = __webpack_public_path__ + "img/main-bn-01.a2ebd95b.jpg";